import React, { memo } from "react";
import './index.css';


const DownTimeMessage = (props: any) => {

    return (
        <body>
        <div className="downTimePage">
            <div className="page-content">
                <h1>Important Note </h1>
                <p className="errorMessage">We've Moved! Find us now at[http://genesis.trinitypaysol.com]. <a href="http://genesis.trinitypaysol.com">Click Here </a> to redirect.</p>
                <p className="errorMessage">- Trinity Payment Solutions</p>
            </div>
        </div>
        </body>
    )
};

export default memo(DownTimeMessage);